import Link from 'next/link';
import { type FC, useContext } from 'react';
import { type Props } from 'src/components/shared/templates/footer/OriginalFooter';
import { KaimonoWebRoutes } from 'src/config/routes';
import { I18nContext } from 'src/stores/I18n';
import { ShopsContext } from 'src/stores/Shops';

export const Shops: FC<Props> = ({ headingLevel }) => {
  const localeResources = useContext(I18nContext);
  const shops = useContext(ShopsContext);
  const Heading = headingLevel === 'h2' ? 'h2' : 'h3';

  return (
    <div className="w-full flex flex-col gap-3">
      <Heading className="border-b border-black border-solid py-2 px-5">{localeResources.shops.list}</Heading>
      <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {shops.map((shop) => (
          <li className="text-sm py-2 px-5" key={shop.id}>
            <Link href={KaimonoWebRoutes.shops.show(shop.slug)}>
              <a className="hover:text-gray700 hover:opacity-70 hover:border-b hover:border-b-black hover:border-solid transition-opacity duration-200">
                {shop.name}
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
